import React from 'react';
import Proforma from '../../components/sales/proforma';
import { useParams } from 'react-router-dom';

export default function ProformaPrint() {
  const { id } = useParams();
  return <Proforma id={id} />;
}
